/**
 * @desc 修改
 */
import { DictEntity, DictForm } from '@eastcoal/api/system/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateDictParameter = DictForm

const method = 'PUT'
const url = '/system/dict'

export const updateDictApi = (
  data?: UpdateDictParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<DictEntity>({
    method,
    url,
    data,
    ...config
  })
}

updateDictApi.method = method
updateDictApi.url = url
